import React from 'react';

const AddCategoryModal = ({
  newCategory,
  setNewCategory,
  createCategory,
  onClose,
  isDarkMode
}) => {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className={`w-full max-w-md rounded-xl ${isDarkMode ? 'bg-gray-800' : 'bg-white'} p-5`}>
        <h3 className={`text-lg font-bold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>Add Category</h3>
        
        <div className="space-y-4">
          <div>
            <label className={`block text-sm mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>Name (ID) *</label>
            <input type="text" value={newCategory.name} onChange={(e) => setNewCategory(prev => ({ ...prev, name: e.target.value.toLowerCase().replace(/\s/g, '_') }))}
              className={`w-full px-3 py-2 rounded-lg border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              placeholder="e.g. food, travel, slang" />
          </div>
          
          <div>
            <label className={`block text-sm mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>Label *</label>
            <input type="text" value={newCategory.label} onChange={(e) => setNewCategory(prev => ({ ...prev, label: e.target.value }))}
              className={`w-full px-3 py-2 rounded-lg border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              placeholder="e.g. Moroccan Food, Travel Tips" />
          </div>
          
          <div>
            <label className={`block text-sm mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>Emoji</label>
            <input type="text" value={newCategory.emoji} onChange={(e) => setNewCategory(prev => ({ ...prev, emoji: e.target.value }))}
              className={`w-full px-3 py-2 rounded-lg border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              placeholder="📚" />
          </div>
        </div>
        
        <div className="flex justify-end gap-2 mt-6">
          <button onClick={onClose} className={`px-4 py-2 rounded-lg text-sm ${isDarkMode ? 'bg-gray-700 text-white' : 'bg-gray-200'}`}>Cancel</button>
          <button onClick={createCategory} disabled={!newCategory.name || !newCategory.label} className="px-4 py-2 bg-purple-600 text-white rounded-lg text-sm disabled:opacity-50">Add Category</button>
        </div>
      </div>
    </div>
  );
};

export default AddCategoryModal;
